/**
 *@file config.js
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/10/17 - 20:37
 *@updateTime 2019/10/17 - 20:37
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 * @description    server-config.js.js ,所有服务器的url配置
 */
const dirServicePath = window.serverConfig.dirServicePath;
// 服务数据
const serverUrl = {
    login: (category) => ({
        // 登录
        login: `${dirServicePath}/user/login`,
        // 忘记密码修改
        forgetPasswd: `${dirServicePath}/user/forgetPassword`,
        // 忘记密码时获取验证码
        sendForgetPasswordSms: `${dirServicePath}/phonecode/forgetPassword`,
        // 注册-获取验证码
        registerGetPasswordSignup: `${dirServicePath}/phonecode/signup`,
        // 注册-提交数据
        registerUserSignup: `${dirServicePath}/user/signup`,
    }[category]),
    home: (category) => ({
        // 信息公示
        news: `${dirServicePath}/news/indexNews`,
        // 轮播图
        banner: `${dirServicePath}/banner/bannerList`,
        // 活动
        hd: `${dirServicePath}/activity/activityList`,
    }[category]),
    gs: (category) => ({
        // 信息公示
        news: `${dirServicePath}/news/newsList`,
        // 公示详情
        newsDetail: `${dirServicePath}/news/newsDetail`,
    }[category]),
    hd: (category) => ({
        // 活动详情
        hdDetail: `${dirServicePath}/activity/activityDetail`,
        // 报名
        sign: `${dirServicePath}/activity/sign`,
        // 我的活动
        myHd: `${dirServicePath}/activity/userSignList`,
        // 签到
        clockin: `${dirServicePath}/activity/clockin`,
    }[category]),
    rhsq: (category) => ({
        // 列表信息
        registerInfo: `${dirServicePath}/user/registerInfo`,
        // 申请注册
        register: `${dirServicePath}/user/register`,
        // 申请注册
        updateUser: `${dirServicePath}/user/updateUser`,
        // 用户图片
        uploadFile: `${dirServicePath}/upload/user/uploadFile`,
        // 推荐单位
        getTj: `${dirServicePath}/user/tuijiandanweiList`,
    }[category]),
    grzx: (category) => ({
        // 获取个人信息
        getUser: `${dirServicePath}/user/getUserByToken`,
        // 修改个人信息
        updateUser: `${dirServicePath}/user/updateUser`,
        // 会员名录
        getHyml: `${dirServicePath}/user/memberList`,
        // 会员名录列表
        getHymlList: `${dirServicePath}/user/memberByXiehuizhiwuId`,
        // 会员名录详情
        getHymlDetil: `${dirServicePath}/user/memberDetail`,
        // 积分记录
        getJfjl: `${dirServicePath}/user/userPointRecord`,
        // 证书列表
        getZs: `${dirServicePath}/certificate/userCertificate`,
        // 签到获取个人信息
        getJdUser: `${dirServicePath}/user/verifyUserByToken`,
    }[category]),
    common: (category) => ({
        // 扫码
        wxshare: `${dirServicePath}/wxshare/getConfig`,
    }[category]),

};
export default serverUrl;



// WEBPACK FOOTER //
// ./src/js/server-config.js